<template>
  <div>
    <div ref="menuRef" style="position: relative">
      <!-- hamburger button -->
      <button @click="toggleMenu" class="nav-btn">
        <div class="tooltip">Menu</div>
        <span class="material-icons-round btn-icon"> menu </span>
      </button>

      <!-- dropdown menu -->
      <div v-if="isOpen" class="menu">
        <button @click="handleClick('showPrevBoardPopup')" class="menu-item first">
          <span class="material-icons-round btn-icon"> calendar_month </span>
          <div class="menu-label">Archive</div>
        </button>
        <div class="divider" />
        <button @click="handleClick('showTeuteufGamesPopup')" class="menu-item">
          <span class="material-icons-round btn-icon"> videogame_asset </span>
          <div class="menu-label">More Games</div>
        </button>
        <div class="divider" />
        <button @click="handleClick('showCategoryInfoPopup')" class="menu-item">
          <span class="material-icons-round btn-icon"> format_list_bulleted </span>
          <div class="menu-label">Categories Info</div>
        </button>
        <div class="divider" />
        <button @click="handleOpenFeedbackForm" class="menu-item">
          <span class="material-icons-round btn-icon"> feedback </span>
          <div class="menu-label">Submit Feedback</div>
        </button>
        <div class="divider" />
        <button @click="handleClick('showGameInfoPopup')" class="menu-item last">
          <span class="material-icons-round btn-icon"> question_mark </span>
          <div class="menu-label">How to play</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, onBeforeUnmount } from 'vue';

  export default {
    name: 'HamburgerMenu',
    setup() {
      const isOpen = ref(false);
      const menuRef = ref(null);

      const handleDocumentClick = (event) => {
        if (!isOpen.value) return;
        if (!menuRef.value) return;

        const path = event.composedPath ? event.composedPath() : [];
        if (!path.includes(menuRef.value)) {
          isOpen.value = false;
        }
      };
      onMounted(() => {
        document.addEventListener('click', handleDocumentClick);
      });

      onBeforeUnmount(() => {
        document.removeEventListener('click', handleDocumentClick);
      });

      return {
        isOpen,
        menuRef,
      };
    },
    methods: {
      toggleMenu() {
        this.isOpen = !this.isOpen;
      },
      handleClick(functionToEmit) {
        this.$emit(functionToEmit);
        this.toggleMenu();
      },
      handleOpenFeedbackForm() {
        window.open(
          'https://teuteuf.notion.site/17eeff4e9f3880e2a6aeef075e74939b?pvs=105',
          '_blank'
        );
        this.toggleMenu();
      },
    },
  };
</script>

<style scoped>
  .nav-btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 8px;
    background-color: rgba(76, 76, 103, 1);
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .nav-btn:hover {
    background-color: rgba(42, 42, 58, 1);
  }

  .btn-icon {
    font-size: 24px;
    color: rgba(173, 173, 234, 1);
  }

  .nav-btn.avatar {
    width: 40px;
    background-size: cover;
    background-position: center;
  }

  .tooltip {
    position: absolute;
    bottom: -36px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(32, 32, 44, 1);
    color: #fff;
    padding: 5px 10px;
    border-radius: 12px;
    white-space: nowrap;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    font-size: 12px;
  }

  .nav-btn:hover .tooltip {
    opacity: 1;
  }

  .menu {
    position: absolute;
    z-index: 99;
    right: 0;
    margin-top: 10px;
    min-width: 150px;
    border-radius: 16px;
    background-color: rgba(76, 76, 103, 1);
    overflow: hidden;
    text-align: start;
    white-space: nowrap;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  }

  .menu-item {
    background-color: rgba(76, 76, 103, 1);
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    color: rgb(223, 223, 223);
    cursor: pointer;
    border: none;
    text-decoration: none;
    width: 100%;
  }

  .menu-label {
    font-size: 14px;
  }

  .menu-item:hover {
    background-color: rgba(42, 42, 58, 1);
  }

  .menu-item.first {
    padding-top: 16px;
  }

  .menu-item.last {
    padding-bottom: 16px;
  }

  .divider {
    display: flex;
    height: 1px;
    background-color: rgba(42, 42, 58, 1);
    margin-left: 8px;
    margin-right: 8px;
  }
</style>
